module.exports = __webpack_public_path__ + "img/nki_hun_white.5d664e99.png";